"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.dark = void 0;
const color_1 = __importDefault(require("./tokens/color"));
const colorPalette_1 = __importDefault(require("./tokens/colorPalette"));
const size_1 = __importDefault(require("./tokens/size"));
const spacing_1 = __importDefault(require("./tokens/spacing"));
const timing_1 = __importDefault(require("./tokens/timing"));
const typography_1 = __importDefault(require("./tokens/typography"));
const typographySet_1 = require("./tokens/typographySet");
const color_dark_1 = __importDefault(require("./tokens/color-dark"));
/** @deprecated Use OxygenProvider */
const novo = {
    ...color_1.default,
    ...colorPalette_1.default,
    ...size_1.default,
    ...spacing_1.default,
    ...timing_1.default,
    ...typography_1.default,
    label01: typographySet_1.label01,
    labelBold01: typographySet_1.labelBold01,
    body01: typographySet_1.body01,
    bodyBold01: typographySet_1.bodyBold01,
    body02: typographySet_1.body02,
    bodyBold02: typographySet_1.bodyBold02,
    prodHeading01: typographySet_1.heading01,
    prodHeading02: typographySet_1.heading02,
};
/** @deprecated Use OxygenProvider */
const dark = {
    ...novo,
    ...color_dark_1.default,
};
exports.dark = dark;
// Novo
exports.default = novo;
